import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  actions: {
    initialiseStore(context) {
      if (localStorage.getItem('store')) {
        const store = JSON.parse(localStorage.getItem('store'))
        context.commit('auth/TOKEN_UPDATE', {
          accessToken: store.accessToken,
          user: store.user,
        })
      }
    },
  },
})
